<script lang="ts">
    import { push } from "svelte-spa-router"
    import { getContext } from "svelte";
    import { sendLogin } from "./src/client"
    import { error } from "itty-router"
    


let login:string;

let password:string;

let errorMessage:string;

let isLoginOk:boolean =  true;

const loadData:(() => Promise<void>) = getContext('loadData');

let logMeIn = async () => {
    console.log('login.LogMeIn()')
    isLoginOk = await sendLogin(login,password);

    if (isLoginOk) {
        console.log(`login.logmein logged `,isLoginOk);
        await loadData();
        push('#/');
    }
    else {
        errorMessage = `Échec de l'authentification.`
    }
    // we're not logged stay here
} 

</script>


{#if !isLoginOk && errorMessage}
    <p style='color:red;font-weight: bold;'>{errorMessage}</p>
{/if}
<label for="login">Login</label>
<input id="login" type="text" bind:value={login}/>
<label for="password">mot de passe :</label>
<input id="password" type="password" bind:value={password}/>
<input type="submit" on:click={logMeIn} value="OK"/>